import digitalData from 'digital-data';
import { MY_HOMEPAGE, STASH, MODULE_CLICK, NOT_APPLICABLE } from '../constants.js';
export const marketingContent = () => {
  const publishAnalytics = function (output) {
    let widgetElement = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'banner';
    const {
      widgetId,
      widgetTemplates,
      widgetCampaign,
      widgetComponent
    } = output;
    const ddoEvent = {
      category: {
        primaryCategory: STASH
      },
      eventInfo: {
        eventName: MODULE_CLICK
      },
      eventMode: STASH,
      stash: {
        pageType: MY_HOMEPAGE,
        content: {
          widgets: [{
            action: NOT_APPLICABLE,
            id: widgetId,
            name: NOT_APPLICABLE,
            templates: widgetTemplates,
            campaign: widgetCampaign,
            component: widgetComponent,
            element: widgetElement
          }]
        }
      }
    };
    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  };
  window.LIFE_CYCLE_EVENT_BUS.on('spotlight.content-click', _ref => {
    let {
      output = {}
    } = _ref;
    publishAnalytics(output);
  });
  window.LIFE_CYCLE_EVENT_BUS.on('hero-flatten.content-click', _ref2 => {
    let {
      output = {}
    } = _ref2;
    publishAnalytics(output);
  });
  window.LIFE_CYCLE_EVENT_BUS.on('capabilities-tiles-click', _ref3 => {
    let {
      output = {}
    } = _ref3;
    publishAnalytics(output, 'capabilities');
  });
};
//# sourceMappingURL=marketing-content.listener.analytics.js.map